<template>
    <div class="user_order no-trans" v-loading="loading">
        <div class="order_titles">
            <div class="order_bordeer"></div>
            我的分享大使
        </div>
        <div class="user_order_box">
            <div class="order_list">
                <div class="list_item">
                    <div class="item_imgs">
                        <img src="@/assets/img/user_info/user_zl/user_img.png" alt="">
                    </div>
                    <div class="item_info">
                        <div class="info_top">
                            <div class="text1">{{sj_data.name}}</div>
                            <div class="text2">{{ sj_data.mobile }}</div>
                            <!-- <div class="text3">身份名称</div> -->
                              <div class="text3" v-if="sj_data.type==1">普通用户</div>
                            <div class="text3" v-if="sj_data.type==2">律师-执业</div>
                            <div class="text3" v-if="sj_data.type==3">律师-非执业</div>
                            <div class="text3" v-if="sj_data.type==4">法律专家</div>
                            <div class="text3" v-if="sj_data.type==5">法律资格从业者</div>
                            <div class="text3" v-if="sj_data.type==6">工商企业</div>
                            <div class="text3" v-if="sj_data.type==7">律所</div>
                        </div>
                        <div class="info_bom">
                            <!-- {{ sj_data.created_at }} -->
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            sj_data:{},
        }
    },
    computed: {
    },
    watch: {

    },
    created() {
        this.get_sj()
    },
    methods: {
       get_sj(){
          this.loading=true
            this.$api("getXiaJiList", {
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的上级',res)
                if (res.code == 1) {
                    this.sj_data=res.data.shangji
                    
                } else {
                    alertErr(res.msg)
                }
            });
       },




    },

}
</script>
<style scoped lang="less">
.user_order {
    background: #FFFFFF;
    height: 100%;
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        // padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E5E5E5;

        .order_bordeer{
            width: 4px;
            height: 22px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
            margin-right: 28px;
        }
    }
    .user_order_box{
        padding: 24px 32px;    
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_list{
            .list_item{
                display: flex;
                align-items: center;
                padding: 20px 10px;
                .item_imgs{
                    width: 90px;
                    height: 90px;
                    img{
                        width: 90px;
                        height: 90px;
                    }
                }
                .item_info{
                    padding-left: 30px;
                    .info_top{
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                            margin-left: 20px;
                        }
                        .text3{
                            width: 87px;
                            height: 31px;
                            background: #377CFD;
                            border-radius: 19px 19px 19px 19px;
                            text-align: center;
                            line-height: 31px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 25px;
                        }
                    }
                    .info_bom{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;

                    }
                }
            }
        }
       
    }


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        font-size: 16px;
        line-height: 1.6;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 44px;
    }
    .user_order.no-trans .order_titles .order_bordeer {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 16px 10px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_imgs {
        width: 90px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_imgs img {
        width: 90px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_info {
        padding-left: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_info .info_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_info .info_top .text1 {
        font-size: 18px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_info .info_top .text2 {
        font-size: 18px;
        margin-left: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_info .info_top .text3 {
        width: 87px;
        height: 31px;
        border-radius: 8px 8px 8px 8px;
        line-height: 31px;
        font-size: 14px;
        margin-left: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .list_item .item_info .info_bom {
        font-size: 14px;
    }
}
</style>
